import { createRoot } from "react-dom/client";

import App from "./App";

import "index.css";
import "assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "assets/sass/theme_overrides.scss";

const root = createRoot(document.getElementById("root")!);

root.render(<App />);
